import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class DemoraVolcadora {
  static getDemoraVolcadora (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`consulta_demora_en_volcadora_entre_fechas?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static adaptToBackend (demoraValues = {}) {
    const {
      fechaInicioDemora,
      fechaFinDemora,
      horaInicio,
      horaFin,
      motivoDemora,
      username,
      volcadoraCamiones,
      observacionesDemora,
      supervisor
    } = demoraValues

    return {
      inicioDeDemora: fechaInicioDemora + ' ' + horaInicio,
      finDeDemora: fechaFinDemora + ' ' + horaFin,
      usuarioAlta: username,
      volcadoraCamiones: volcadoraCamiones,
      motivoDeDemoraEnVolcadora: motivoDemora,
      observacionesSupervisor: observacionesDemora || null,
      usuarioSupervisor: supervisor || null
    }
  }

  static insertDemoraEnVolcadora (demoraValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(demoraValues)
    const promise = axios.post(`demora_en_volcadora`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static updateDemoraEnVolcadora (demoraValues, fechaInicio, volcadora) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(demoraValues)
    const promise = axios.put(`demora_en_volcadora`, { valores: { ...valores },
      clave: { inicio_de_demora: fechaInicio, volcadora_camiones: volcadora } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static deleteDemoraVolcadora (fechaInicio, volcadora) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"inicio_de_demora": "${fechaInicio}", "volcadora_camiones": "${volcadora}"}}`
    const promise = axios.delete(`demora_en_volcadora?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static getMotivosDeDemoraEnVolcadora () {
    const axios = getAxiosInstance()
    const promise = axios.get(`motivo_de_demora_en_volcadora_listado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }
}

export default DemoraVolcadora
